import type { EditorSelectionSurface, EditorState } from '../types';

export const setActiveSelectionSurface = (
  state: EditorState,
  activeSelectionSurface: EditorSelectionSurface,
): EditorState => {
  if (state.activeSelectionSurface === activeSelectionSurface) {
    return state;
  }

  return {
    ...state,
    activeSelectionSurface,
  };
};
